var _polygon, _polygon2, _circle, _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "100,30 160,70 160,130 100,170 40,130 40,70",
    fill: "none",
    stroke: "#E63946",
    strokeWidth: 8
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "100,60 140,80 140,120 100,140 60,120 60,80",
    fill: "#FFF",
    stroke: "#E63946",
    strokeWidth: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 20,
    fill: "#000"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 30,
    x2: 100,
    y2: 60,
    stroke: "#E63946",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 70,
    x2: 140,
    y2: 80,
    stroke: "#E63946",
    strokeWidth: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 130,
    x2: 140,
    y2: 120,
    stroke: "#E63946",
    strokeWidth: 4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 170,
    x2: 100,
    y2: 140,
    stroke: "#E63946",
    strokeWidth: 4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 130,
    x2: 60,
    y2: 120,
    stroke: "#E63946",
    strokeWidth: 4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 70,
    x2: 60,
    y2: 80,
    stroke: "#E63946",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3b1a3665d5115514300fd721d626b61b.svg";
export { ForwardRef as ReactComponent };